import { render, staticRenderFns } from "./SpecRequestPopupWrappable.vue?vue&type=template&id=582d8d1c&scoped=true&lang=pug&"
import script from "./SpecRequestPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./SpecRequestPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./SpecRequestPopupWrappable.vue?vue&type=style&index=0&id=582d8d1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d8d1c",
  null
  
)

export default component.exports